module.exports = __webpack_public_path__ + "img/mono-picture.f9a931fc.svg";